import $ from 'jquery';

let svgs;
let svgCache;

function makeSvgArray(data){
    const array = [];
    const icons = data.getElementsByTagName('symbol');
    for (let i = 0; i <= icons.length - 1; i++) {
        array.push(icons[i].getAttribute('id'));
    }
    return array;
}

function init(){
    $.ajax({
        url: '/assets/gfx/icons.svg'
    }).done(function (data) {
        svgCache = data;
        svgs = makeSvgArray(data);
    });
}

function getSvgArrayFiltered(string){
    const array = [];
    for (let i = 0; i <= svgs.length - 1; i++) {
        const name = svgs[i];
        if (name.indexOf(string) !== -1){
            array.push(svgs[i]);
        }
    }
    return array;

}

function getSvgArray(){
    return svgs;
}

function buildIconsView(containerSelector, filter){
    const container = containerSelector || '.main-content';
    const iconsWrap = $("<div class='iconswrap'>");
    const iconsArray = filter ? getSvgArrayFiltered(filter) : getSvgArray();

    for (let i = 0; i < iconsArray.length; i++){
        const iconSVG = $('<div style="display: inline-block; padding:1em;font-size:10px;border: 1px collapse grey; text-align: center;">' +
            '<svg style="width:50px;height:50px;"><use xlink:href="/assets/gfx/icons.svg#' + iconsArray[i] + '"></use></svg>' +
            '<p>' + iconsArray[i] + '</p>' +
            '</div>');
        iconsWrap.append(iconSVG);
    }
    $(container).append(iconsWrap);
    return 'succes!';
}

export default {
    init: init,
    getSvgArray: getSvgArray,
    getSvgArrayFiltered: getSvgArrayFiltered,
    buildIconsView: buildIconsView
};
